/**
 * @ngdoc decorator
 * @name exceptionHandlerDecorator
 * @description
 * Track when an exception is thrown and create an analytics event for it.
 *
 * @param {Service} $injector To get the required dependencies because annotations cause circular
 *                            dependencies errors.
 * @return {Function}
 */
const exceptionHandlerDecorator = ($injector) => {
  'ngInject';

  return (exception) => {
    const $log = $injector.get('$log');

    $log.error(exception);
  };
};

export default exceptionHandlerDecorator;



// WEBPACK FOOTER //
// ./src/frontend/modules/root/decorators/exceptionHandler.decorator.js